import styles from './index.module.scss'
import { Divider, message } from 'antd'
import { LeftOutlined, RightOutlined, CheckOutlined } from '@ant-design/icons'
import { useCallback, useContext } from 'react'
import Utils from '@/utils/utils'
import API from "@api/api"
import { PictureViewerContext } from '../hooks/PictureViewerContext'

export default function PicViewerBottom ({
    image,
    extraButtons=[],
    onDownload,
    onPrev,
    onNext,
    onStatusChange,
}) {
    const context = useContext(PictureViewerContext)
    const { hasNext, hasPrev } = context
    const { allowStatusDeselect } = context.controls

    const {
        status, // 'approved' | 'rejected' | 'modified' | null
        approveText="可用",
        approvedText="可用",
        rejectText="需修改",
        rejectedText="需修改",
        cancelText="取消",
        canceledText="已取消",
        approveDisabled=false, // 是否禁用可用按钮
        rejectDisabled=false, // 是否禁用拒绝按钮
        cancelDisabled=false, // 是否禁用取消按钮
        downloadDisabled=true, // 是否禁用下载按钮
        readOnly=false, // 是否只读模式
    } = image

    const handleStatusChange = useCallback(async (nextStatus) => {
        try {
            await onStatusChange?.(nextStatus)
            if (nextStatus == "approved" && hasNext) {
                onNext()
            }
        } catch (err) {
            console.error(err)
        }
    }, [onStatusChange, hasNext, onNext])

    const handleDownload = useCallback(async () => {
        if (!image) return
        console.log('image', image)
        if (onDownload) {
            await onDownload(image)
        } else {
            const url = image.url
            const filename = image.name
            const extension = url.split('?').shift().split('.').pop()
            Utils.downloadUrl(url, filename ? `${filename}.${extension}` : null)
        }
        message.success("图片已下载")
        // // 下载图片埋点
        if (image.id) API.trackImageDownload([image.id])
    }, [onDownload, image])

    return (
        <div className={styles.PicViewerBottom}>
            {/** extra buttons 占位符 */}
            <div className={styles.ExtraButtons}>
                {extraButtons}
            </div>
            { extraButtons.length > 0 ? <Divider type="vertical" style={{height: 28, margin: 0}} /> : null }
            <div className={styles.CenterGroup}>
                <PreNextGroup
                    hasPrev={hasPrev}
                    hasNext={hasNext}
                    onPrev={onPrev}
                    onNext={onNext}
                />
            </div>
            <Divider type="vertical" style={{height: 28, margin: 0}} />
            <div className={styles.RightGroup}>
                {downloadDisabled ? null :
                <div
                    className={`${styles.ActionBtn} ${styles.Secondary}`}
                    onClick={handleDownload}
                >
                    下载
                </div>}
                <div
                    className={`${styles.ActionBtn} ${styles.Tertiary} ${status === 'canceled' ? styles.active : ''} ${(readOnly || cancelDisabled) ? styles.disabled : ''}`}
                    style={(readOnly || cancelDisabled) && status != "canceled" ? {display:"none"} : null}
                    onClick={(readOnly || cancelDisabled) ? undefined : () => handleStatusChange?.(status === 'canceled' && allowStatusDeselect ? null : 'canceled')}
                >
                    {status == "canceled" ? <CheckOutlined /> : null}
                    {status == "canceled" ? canceledText : cancelText}
                </div>
                <div
                    className={`${styles.ActionBtn} ${styles.Secondary} ${status === 'rejected' ? styles.active : ''} ${(readOnly || rejectDisabled) ? styles.disabled : ''}`}
                    style={(readOnly || rejectDisabled) && status != "rejected" ? {display:"none"} : null}
                    onClick={(readOnly || rejectDisabled) ? undefined : () => handleStatusChange?.(status === 'rejected' && allowStatusDeselect ? null : 'rejected')}
                >
                    {status == "rejected" ? <CheckOutlined /> : null}
                    {status == "rejected" ? rejectedText : rejectText}
                </div>
                <div
                    className={`${styles.ActionBtn} ${styles.Primary} ${(!status || status === 'modified') ? styles.default : status === 'approved' ? styles.active : ''} ${(readOnly || approveDisabled) ? styles.disabled : ''}`}
                    style={(readOnly || approveDisabled) && status != "approved" ? {display:"none"} : null}
                    onClick={(readOnly || approveDisabled) ? undefined : () => handleStatusChange?.(status === 'approved' && allowStatusDeselect ? null : 'approved')}
                >
                    {status == "approved" ? <CheckOutlined /> : null}
                    {status == "approved" ? approvedText : approveText}
                </div>
            </div>
        </div>
    )
}

function PreNextGroup ({ hasPrev, hasNext, onPrev, onNext }) {
    return (
        <div className={styles.PreNextGroup}>
            <div
                title="上一张"
                className={`${styles.NavBtn} ${!hasPrev ? styles.disabled : ''}`}
                onClick={hasPrev ? onPrev : undefined}
            >
                <LeftOutlined />
            </div>
            <div
                title="下一张"
                className={`${styles.NavBtn} ${!hasNext ? styles.disabled : ''}`}
                onClick={hasNext ? onNext : undefined}
            >
                <RightOutlined />
            </div>
        </div>
    )
}
